import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import {
    FETCH_EVENTS, FETCH_GAME_BETS_ERROR, GAME_UPDATE, FETCH_EVENTS_ERROR, getActiveEvents, getEventBets, EVENTS_SET_ACTIVE, EVENTS_POST_BET
} from '../constants/action-types';

/**
 * Potential socket game updates
 * @param {*} param0 
 */
function* gameUpdate({ game }) {


}

export default [
    takeLatest(GAME_UPDATE, gameUpdate)
]


// WEBPACK FOOTER //
// ./src/sagas/game.js